import React from "react";

import {
	Box,
	Container,
	Grid,
	Typography
} from "@mui/material";
import { Trans } from "@lingui/macro";
import { ActionCard } from "components/backoffice/action-card/action-card";
import * as MUIcon from "@mui/icons-material";
import { ChooseActionState } from "./models";
import { UserRole } from "models";

interface Action {
	href: string
	icon: keyof typeof MUIcon
	description: string
	descriptionId: string
	enabled: boolean
}

const ACTION: Action[] = [
	{
		href: "/backoffice/manage-content",
		icon: "Videocam",
		description: "Contenuti",
		descriptionId: "ca-content-card",
		enabled: true
	},
	{
		href: "/backoffice/manage-list",
		icon: "AutoAwesomeMotion",
		description: "Liste contenuti",
		descriptionId: "ca-content-list-card",
		enabled: (process.env.REACT_APP_CONTENT_LIST_ENABLED === "true")
	},
	{
		href: "/backoffice/series",
		icon: "Dvr",
		description: "Serie",
		descriptionId: "ca-series-management",
		enabled: (process.env.REACT_APP_SERIES_ENABLED === "true")
	},
	{
		href: "/backoffice/manage-actions",
		icon: "SettingsSuggest",
		description: "Gestione",
		descriptionId: "ca-manage-card",
		enabled: true
	},
	{
		href: "/backoffice/subscription-actions",
		icon: "Style",
		description: "Codici e abbonamenti",
		descriptionId: "ca-subscription-management-card",
		enabled: (process.env.REACT_APP_CODES_AND_SUBS_ENABLED === "true")
	}
];

const ADMIN_ACTION: Action[] = [
	{
		href: "/backoffice/manage-user",
		icon: "Group",
		description: "Utenti",
		descriptionId: "ca-user-card",
		enabled: (process.env.REACT_APP_USERS_ENABLED === "true")
	},
];

export class ChooseAction extends React.Component<{}, ChooseActionState> {

	constructor(props: any) {
		super(props);

		this.state = {
			user: null,
		}
	}

	componentDidMount() {
		let currentUser = localStorage.getItem("current_user");
		if (currentUser)
			this.setState({ user: JSON.parse(currentUser) });
	}

	render() {

		return (<Box p={5}>
			<Box className="h-catalog-title" textAlign="center" marginBottom={8}>
				<Typography variant="h1"
					sx={{
						color: process.env.REACT_APP_DEFAULT_TEXT_COLOR,
						fontWeight: "bold",
						textTransform: "uppercase"
					}}>
					<Trans id="ca-backoffice-title">Backoffice</Trans>
				</Typography>
			</Box>
			<Container maxWidth="lg">
				<Grid container rowSpacing={3}>
					{ACTION.filter(x => x.enabled).map((item, i) => (
						<Grid item xs={12} md={6} lg={4}
							key={i}
							display="flex"
							justifyContent="center"
							alignItems="center">
							<ActionCard href={item.href} icon={item.icon} description={item.description} descriptionId={item.descriptionId} />
						</Grid>
					))}
					{this.state.user?.role === UserRole.ADMIN && ADMIN_ACTION.filter(x => x.enabled).map((item, i) => (
						<Grid item xs={12} md={6} lg={4}
							key={i}
							display="flex"
							justifyContent="center"
							alignItems="center">
							<ActionCard href={item.href} icon={item.icon} description={item.description} descriptionId={item.descriptionId} />
						</Grid>
					))}
				</Grid>
			</Container>
		</ Box>);
	}
}
